import { useReducer } from 'react';

const ACTION_TYPES = {
  SET_ITEMS: 'SET_ITEMS',
  SET_SELECTED_ITEM: 'SET_SELECTED_ITEM',
  RESET: 'RESET'
};

const ACTIONS = {
  setItems: items => ({
    type: ACTION_TYPES.SET_ITEMS,
    payload: {
      items
    }
  }),

  setSelectedItem: selectedItem => ({
    type: ACTION_TYPES.SET_SELECTED_ITEM,
    payload: {
      selectedItem
    }
  }),

  reset: () => ({
    type: ACTION_TYPES.RESET
  })
};

const reducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.SET_ITEMS: {
      const { payload: { items } } = action;
      return { ...state, items };
    }

    case ACTION_TYPES.SET_SELECTED_ITEM: {
      const { payload: { selectedItem } } = action;
      return { ...state, selectedItem };
    }

    case ACTION_TYPES.RESET: {
      return dropdownInitialState;
    }

    default: {
      throw Error('useDropdown reducer default should never hit');
    }
  }
};

const dropdownInitialState = {
  items: [], // { label: '', value: 0 }
  selectedItem: '-1'
};

const useDropdown = () => {
  const [state, dispatch] = useReducer(reducer, dropdownInitialState);

  const setItems = items => dispatch(ACTIONS.setItems(items));

  const setSelectedItem = e => {
    const selectedItem = e.target.value;
    e.preventDefault();
    e.stopPropagation();
    dispatch(ACTIONS.setSelectedItem(selectedItem));
  };

  const reset = () => dispatch(ACTIONS.reset());

  const boundActions = {
    setItems,
    setSelectedItem,
    reset
  };

  return [state, boundActions];
};

export default useDropdown;
